export enum valoresCoberturas {
  CINCO_MIL = "R$ 5.000,00",
  DEZ_MIL = "R$ 10.000,00",
  CINQUENTA_MIL = "R$ 50.000,00",
  CEM_MIL = "R$ 100.000,00",
  CENTO_E_CINQUENTA_MIL = "R$ 150.000,00",
  DUZENTOS_MIL = "R$ 200.000,00",
}
